var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pub-btn",on:{"click":_vm.addTopic}},[_c('span',{staticClass:"icon-publish"}),_c('span',{staticClass:"pub-info"},[_vm._v("发布帖子")])])}
var staticRenderFns = []

export { render, staticRenderFns }